import { combineReducers } from 'redux';

import SessionErrorsReducer from './session_errors_reducer';
import WIErrorsReducer from './wi_errors_reducer'

export default combineReducers({
    session: SessionErrorsReducer,
    wi: WIErrorsReducer
});